import { FunctionComponent, useContext } from "react";
import { ReactReduxContext } from "react-redux";

import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { useIsFeatureActive } from "@/utils/useIsFeatureActive";
import { FeaturesCodes } from "@/pages/Private/pages/Users/enum/codes";

import {
	closeHelpPanel,
	helpCenterSelector,
} from "@/pages/Private/redux/helpCenter/helpCenter.slice";

import { HelpPanel } from "./HelpPanel";

const HelpPanelBody: FunctionComponent = () => {
	const dispatch = useAppDispatch();
	const isActive = useIsFeatureActive(FeaturesCodes.HELP_CENTER);

	const { isPanelOpen } = useAppSelector(helpCenterSelector);

	if (!isActive) {
		return null;
	}

	return <HelpPanel isOpen={isPanelOpen} onClose={() => dispatch(closeHelpPanel())} />;
};

/**
 * Renders the help chat panel once for the whole app. Every launcher — the header ones and the
 * pinned fallback — only toggles the slice, so the panel needs exactly one host; mounting it per
 * launcher gave one slice two portals whenever two headers were on screen at once.
 */
export const HelpPanelHost: FunctionComponent = () => {
	const reduxContext = useContext(ReactReduxContext);

	if (!reduxContext) {
		return null;
	}

	return <HelpPanelBody />;
};
